export default "__VITE_ASSET__BZXjN4zL__"